import { call, put, select, takeLatest } from 'redux-saga/effects';
import {
  FETCH_ACTION_CATALOG,
  CREATE_ACTION,
  UPDATE_ACTION,
  DELETE_ACTION,
  REORDER_ACTIONS,
  fetchActionCatalog,
  fetchActionCatalogSuccess,
  actionCatalogError
} from '../../redux/actions/trm/actionCatalog';
import ActionCatalogModule from '../../services/trm/apiModules/ActionCatalogModule';

const apiModule = new ActionCatalogModule();

const extractError = (err) => {
  // axios with validateStatus:false returns data on the response object even on 4xx/5xx
  const resp = err?.response;
  const data = resp?.data;
  if (data && typeof data === 'object') {
    return data;
  }
  return { message: err?.message || 'Action catalog request failed' };
};

function* fetchSaga(action) {
  // Allow forced refresh via { type: FETCH, payload: { force: true } }.
  // Multiple components dispatch fetchActionCatalog() unconditionally on mount;
  // without this guard each scenario navigation triggers N redundant API calls.
  const force = action?.payload?.force === true;
  if (!force) {
    const existing = yield select((s) => s.actionCatalog?.rows);
    if (Array.isArray(existing) && existing.length > 0) {
      // Data already cached — dispatch SUCCESS so the reducer clears the
      // `loading:true` set by the FETCH action. Without this, the Table's
      // `loading` prop stays true on second-visit and the spinner spins forever
      // over already-rendered rows (perf 2026-08-01).
      yield put(fetchActionCatalogSuccess(existing));
      return;
    }
  }
  try {
    const rows = yield call(apiModule.list);
    yield put(fetchActionCatalogSuccess(rows));
  } catch (err) {
    yield put(actionCatalogError(extractError(err)));
  }
}

function* createSaga(action) {
  try {
    yield call(apiModule.create, action.payload);
    yield put(fetchActionCatalog({ force: true }));
  } catch (err) {
    yield put(actionCatalogError(extractError(err)));
  }
}

function* updateSaga(action) {
  try {
    const { originalName, payload } = action.payload;
    yield call(apiModule.update, originalName, payload);
    yield put(fetchActionCatalog({ force: true }));
  } catch (err) {
    yield put(actionCatalogError(extractError(err)));
  }
}

function* deleteSaga(action) {
  try {
    yield call(apiModule.remove, action.payload);
    yield put(fetchActionCatalog({ force: true }));
  } catch (err) {
    yield put(actionCatalogError(extractError(err)));
  }
}

function* reorderSaga(action) {
  try {
    yield call(apiModule.reorder, action.payload);
    yield put(fetchActionCatalog({ force: true }));
  } catch (err) {
    yield put(actionCatalogError(extractError(err)));
  }
}

export function* watchFetchActionCatalog() {
  yield takeLatest(FETCH_ACTION_CATALOG, fetchSaga);
}
export function* watchCreateAction() {
  yield takeLatest(CREATE_ACTION, createSaga);
}
export function* watchUpdateAction() {
  yield takeLatest(UPDATE_ACTION, updateSaga);
}
export function* watchDeleteAction() {
  yield takeLatest(DELETE_ACTION, deleteSaga);
}
export function* watchReorderActions() {
  yield takeLatest(REORDER_ACTIONS, reorderSaga);
}
